export const EMAIL_REGEX =
  /^(?=.{1,254}$)(?=.{1,64}@.{1,255}$)[A-Za-z0-9!#$%'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%'*+/=?^_`{|}~-]+)*@(?:(?!-)[A-Za-z0-9-]{1,63}(?![A-Za-z0-9-])\.)+(?!-)[A-Za-z]{2,6}$/;
